"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PASSWORD_MAX_LENGTH = 60;
var _default = exports.default = PASSWORD_MAX_LENGTH;